export const ecommerce = "/ecommerce"